export const ASSURANT_COVERAGES_SYSTEM_PROCESS_NAME = "Coberturas Assurant" as const;
